export function createForm(method, action, formDataList) {
    var form = document.createElement('form');

    form.method = method;
    form.action = action;
    form.setAttribute('style', 'display:none');

    for (var key in formDataList) {
        var input = document.createElement('input');
        input.setAttribute('name', key);
        input.setAttribute('type', 'text');
        input.setAttribute('value', formDataList[key] || '');
        form.appendChild(input);
    }

    document.body.appendChild(form);
    return form;
}
